import { render, staticRenderFns } from "./IcoLanguageEnglish.vue?vue&type=template&id=0158f2ac"
import script from "./IcoLanguageEnglish.vue?vue&type=script&lang=js"
export * from "./IcoLanguageEnglish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports